export function getEndsInLabel(endDateStr: string): string | null {
  if (!endDateStr) {
    return null;
  }
  const endDate = new Date(endDateStr);

  if (isNaN(endDate.getTime())) {
    return null;
  }

  const now = new Date();
  // Adjust both to UTC for comparison
  const utcNow = new Date(
    Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds()
    )
  );
  const utcEnd = new Date(
    Date.UTC(
      endDate.getUTCFullYear(),
      endDate.getUTCMonth(),
      endDate.getUTCDate(),
      endDate.getUTCHours(),
      endDate.getUTCMinutes(),
      endDate.getUTCSeconds()
    )
  );

  const diffMs = utcEnd.getTime() - utcNow.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  // Helper: is same UTC calendar day?
  const isToday =
    utcNow.getUTCFullYear() === utcEnd.getUTCFullYear() &&
    utcNow.getUTCMonth() === utcEnd.getUTCMonth() &&
    utcNow.getUTCDate() === utcEnd.getUTCDate();

  if (isToday) {
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    if (diffHours <= 18) {
      return "TONIGHT";
    }
    return "TODAY";
  }

  // Check if ends tomorrow (difference in days is 1)
  const tomorrow = new Date(utcNow);
  tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
  const isTomorrow =
    tomorrow.getUTCFullYear() === utcEnd.getUTCFullYear() &&
    tomorrow.getUTCMonth() === utcEnd.getUTCMonth() &&
    tomorrow.getUTCDate() === utcEnd.getUTCDate();
  if (isTomorrow) {
    return "TOMORROW";
  }

  // If within next 6 days, return ENDS <WEEKDAY>
  if (diffDays <= 6 && diffDays > 0) {
    // Handle the edge case: if end time is 00:00, adjust to previous day
    let adjustedEnd = new Date(utcEnd);
    if (adjustedEnd.getUTCHours() === 0 && adjustedEnd.getUTCMinutes() === 0) {
      adjustedEnd = new Date(adjustedEnd.getTime() - 1000);
    }
    const weekdaySymbols = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const weekdayName = weekdaySymbols[adjustedEnd.getUTCDay()];
    return weekdayName.toUpperCase();
  }

  if (diffDays > 0) {
    return ` IN ${diffDays} DAYS`;
  }

  return null;
}
